import { Injectable, inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, catchError, throwError, tap } from 'rxjs';
import { HttpService } from '../http/http.service';
import { ENDPOINTS } from '../../constants/endpoints';

@Injectable({
  providedIn: 'root',
})
export class DrawerService {
  private httpService = inject(HttpService);
  private toastrService = inject(ToastrService);


  /**
   * Fetch record dynamically by module name and ID
   * Uses your existing endpoint + query param convention
   */
  getRecordByModuleAndId(moduleName: string, recordId: number): Observable<any> {
    const endpoint = this.getEndpointForModule(moduleName);

    return this.httpService.get<any>(`${endpoint}?id=${recordId}`).pipe(
      tap(() => {
        // Optionally handle logging or loader state
      }),
      catchError((error) => {
        this.toastrService.error(`Failed to load ${moduleName} details.`);
        return throwError(() => error);
      })
    );
  }

  /**
   * Resolves endpoint from ENDPOINTS based on module name
   * Extend this with more cases if you have other entities
   */
  private getEndpointForModule(moduleName: string): string {
    switch (moduleName.toLowerCase()) {
      case 'user':
        return `${ENDPOINTS.User.GetUser}`;
    //   case 'role':
    //     return `${ENDPOINTS.Role.GetRole}`;
    //   case 'team':
    //     return `${ENDPOINTS.Team.GetTeam}`;
    //   case 'template':
    //     return `${ENDPOINTS.Template.GetTemplate}`;
      default:
        this.toastrService.warning(
          `Unknown module: ${moduleName}. Using default endpoint.`
        );
        return ''; // Default or throw error as needed
    }
  }
}
